import styled from '@emotion/styled';
import { Radio, Tooltip, tokens } from '@hotjar/hotsauce';
import type { RadioProps } from '@hotjar/hotsauce';

const StyledFilterItemRadio = styled(Radio)`
  margin-bottom: 0;
  text-transform: initial;
`;

const TooltipWrapper = styled.div`
  display: inline-block;
`;

interface FilterItemRadioProps extends RadioProps {
  tooltipValue?: string;
}

export const FilterItemRadio = ({ tooltipValue, ...props }: FilterItemRadioProps): JSX.Element => {
  if (tooltipValue !== undefined) {
    return (
      <div>
        <Tooltip text={tooltipValue} placement="right">
          <TooltipWrapper>
            <StyledFilterItemRadio {...props} />
          </TooltipWrapper>
        </Tooltip>
      </div>
    );
  }

  return <StyledFilterItemRadio {...props} />;
};

export const FilterRadioContainer = styled.div`
  ${tokens.flexContainer('form', { gap: tokens.spacer.x1 })}
`;
